import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVesselDome = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 95.38,
	height: 55,
	viewBox: "0 0 95.38 55.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 87.69 14.93 A 5.0 13.0 179.97 1 1 87.71 54.93 L 7.71 54.97 A 5.0 13.0 179.97 1 1 7.69 14.97 L 52.69 14.94 L 52.68 4.94 A 10.0 5.0 179.97 0 1 72.68 4.93 L 72.69 14.93 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVesselDome;
